var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.items),function(item,index){return _c('collapse-menu-item',{key:((item.name) + "-" + index),attrs:{"item":item},scopedSlots:_vm._u([{key:item.name,fn:function(){return [_vm._t(item.name)]},proxy:true}],null,true)})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }